import * as React from "react";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {VeBoxCard} from "../../../components/card/VeBoxCard";

declare var AppTranslations: AppTranslations;

interface WarningBannerProps {
    equipmentNotValid?: number;
    onRemove: () => void;
}

export const WarningBanner: React.FC<WarningBannerProps> = ({equipmentNotValid, onRemove}) => {
    const texts = AppTranslations.massiveActions.massiveActionsCommon;
    return (
        <VeBoxCard className={"warning-notification centered flx-row flx-space-between"} style={{margin: "5px 0px"}}>
            <p className={"bold"}>
                {(equipmentNotValid > 0) && <> {equipmentNotValid} {equipmentNotValid === 1 ? texts.equipmentLabel : texts.equipmentLabelPlural}
                    <span className={"not-found"}> {equipmentNotValid === 1 ? texts.notFoundSingle.toLowerCase() : texts.notFoundPlural.toLowerCase()} </span> </>}
            </p>
            <span className={"suggestion"} onClick={onRemove}> {texts.removeThemFromList}</span>
        </VeBoxCard>
    )
}